/**
 * @fileoverview This file initializes and configures Braintrust logging for LLM usage. It provides functions to track LLM inputs, outputs, and token usage, as well as a wrapper for tracing asynchronous operations.
 */

import { LlmPricing, Message } from '@iterator/shared-node/ai/llm_types'
import { initLogger, Span, StartSpanArgs, traced } from 'braintrust'
import { AwolfSettings } from '../settings'

const apiKey = AwolfSettings.singleton().get('BRAINTRUST_API_KEY')

if (apiKey) {
  initLogger({
    projectName: 'Tab Complete',
    apiKey,
  })
}

export function trackLlmUsage(
  span: Span,
  messages: Message[],
  output: any,
  promptTokens: number,
  completionTokens: number,
  model: LlmPricing,
) {
  if (!apiKey) {
    return
  }

  span.log({
    input: messages,
    output,
    metrics: {
      prompt_tokens: promptTokens,
      completion_tokens: completionTokens,
      estimated_cost:
        promptTokens * model.promptTokenCost + completionTokens * model.completionTokenCost,
    },
  })
}

export function trace<T>(fn: (span: Span) => Promise<T>, args?: StartSpanArgs): Promise<T> {
  if (!apiKey) {
    return fn({} as Span)
  }
  return traced(fn, args)
}
